import { HANDLE_MODALS, HANDLE_MODALS_DATA } from '../actionTypes';
import { deepClone } from '../../utils/global_functions';
import { getAllHoldingScrips } from './holdings';



export const handleModal = (modalArray, persist) => async (dispatch, getState) => {
  let modal = deepClone(getState()?.modals?.modals);
  let deleteData;
  for (let i = 0; i < modalArray.length; i++) {
    const key = Object.keys(modalArray[i])[0];
    const value = Object.values(modalArray[i])[0];
    if (!value && !persist) {
      deleteData = true;
    } else if (!value && persist) {
      deleteData = false;
    }
    modal = { ...modal, [key]: value };
    //Azeem K : 10-04-2024 : BT-102298 - Breeze - Single Scrip Order entry - NSEEQ fetch latest holding when order entry window open - Start
    if (key === 'ORDER_ENTRY_MODAL' && modalArray[i][key] === true) {
      dispatch(getAllHoldingScrips());
    }
  }
  //Azeem K : 10-04-2024 : BT-102298 - Breeze - Single Scrip Order entry - NSEEQ fetch latest holding when order entry window open  - End              }

  if (deleteData) {
    dispatch(updateModalData({}));
    dispatch(updateModalObject(modal));
  } else {
    dispatch(updateModalObject(modal));
  }
  return Promise.resolve();
};

export const closeAllModals = () => async (dispatch, getState) => {
  let modal = deepClone(getState()?.modals?.modals);

  Object.keys(modal)?.forEach((eachModal) => modal[eachModal] = false);

  dispatch(updateModalObject(modal));
};

export const updateModalObject = (payload) => {
  return { type: HANDLE_MODALS, payload };
};


export const handleModalData = (obj) => async (dispatch, getState) => {
  const existingObject = { ...getState()?.modals?.modalData, ...obj };
  if (existingObject) {
    dispatch(updateModalData(existingObject));
  }
};


export const updateModalData = (payload) => {
  return { type: HANDLE_MODALS_DATA, payload };
};